import { useCallback } from 'react';
import { getLocationAddress } from '../../../../utils/GeoCoder';
import { setOrders, setSolutionJson } from '../../../../actions';

export function useMarkerCreation(
  dispatch,
  ordersRef,
  solutionRef,
  userRef,
  oAuthRef,
  shouldRefitBoundsRef,
) {
  const updateOrderLocation = useCallback(
    (jobId, address, lat, lng) => {
      const indexFound = ordersRef.current.findIndex((order) => order.InternalID === jobId);

      if (indexFound !== -1) {
        const updatedOrders = [...ordersRef.current];
        updatedOrders[indexFound] = {
          ...updatedOrders[indexFound],
          Address: address,
          Lat: lat,
          Lng: lng,
        };
        dispatch(setOrders(updatedOrders, false, solutionRef.current.show));
        dispatch(setSolutionJson({ jsonTriggerVRP: true }));
      }
    },
    [dispatch, ordersRef, solutionRef],
  );

  const onMarkerDragEnd = useCallback(
    (marker, feature) => {
      const position = marker.getGeometry();

      getLocationAddress(position, oAuthRef.current, userRef.current)
        .then((item) => {
          updateOrderLocation(
            feature.properties.id,
            item.address.label,
            position.lat,
            position.lng,
          );
          shouldRefitBoundsRef.current = true;
        })
        .catch((error) => {
          console.error('Failed to get location address:', error);
          updateOrderLocation(feature.properties.id, '', position.lat, position.lng);
          shouldRefitBoundsRef.current = true;
        });
    },
    [updateOrderLocation, oAuthRef, userRef, shouldRefitBoundsRef],
  );

  return { onMarkerDragEnd };
}
